import { useEffect, useState } from 'react';
import { getBackendToken, getRefreshToken } from '../../../lib/tokenProvider';
import { useAuthStore } from '../../../stores';

/**
 * Syncs the bi-api bearer tokens provided by the Angular host
 * (`window.LOOKER_CONFIG.authToken` and `window.LOOKER_CONFIG.refreshToken`)
 * into `useAuthStore` so legacy consumers that read from the store keep
 * working. The store is the source of truth once populated — subsequent
 * refreshes performed by `baseApi` update the store, not `window`.
 */
export const useAuth = () => {
  const [token, setToken] = useState<string | null>(() => getBackendToken());
  const setAccessToken = useAuthStore((state) => state.setAccessToken);
  const setRefreshTokenInStore = useAuthStore((state) => state.setRefreshToken);

  useEffect(() => {
    const currentAccess = getBackendToken();
    if (currentAccess) {
      setAccessToken(currentAccess);
      setToken(currentAccess);
    }

    const currentRefresh = getRefreshToken();
    if (currentRefresh) {
      setRefreshTokenInStore(currentRefresh);
    }
  }, [setAccessToken, setRefreshTokenInStore]);

  return {
    token,
  };
};
